import { Component, OnInit, Inject, } from '@angular/core';
import { bulmaCarousel } from 'bulma-carousel/dist/js/bulma-carousel.min.js';
import { AfterContentInit, Input, ChangeDetectionStrategy, ViewEncapsulation } from '@angular/core';
import { LazyLoadScriptService } from './lazy-load-script.service';
import { map, filter, take, switchMap } from 'rxjs/operators';
declare var $;
@Component({
  selector: 'app-donation',
  templateUrl: './donation.component.html',
  styleUrls: ['./donation.component.css']
})
export class DonationComponent {


  constructor(public lazyLoadService :LazyLoadScriptService) {

  }
  

  ngAfterContentInit() {
    this.lazyLoadService.loadScript('https://cdnjs.cloudflare.com/ajax/libs/jquery/3.3.1/jquery.min.js')
      .pipe(
        map(_ => 'jQuery is loaded'),
        filter(jquery => !!jquery),
        take(1),
        switchMap(_ => this.lazyLoadService.loadScript('https://cdn.jsdelivr.net/npm/bulma-carousel@4.0.4/dist/js/bulma-carousel.min.js')),
      )
      .subscribe(_ => {

        $('.slider-for').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          fade: true,
          asNavFor: '.slider-nav'
        });
        $('.slider-nav').slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          asNavFor: '.slider-for',
          dots: true,
          focusOnSelect: true
        });

        $('.multiple-items').slick({
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 3
        });
      
      });
  }

}
